export class EventLanding {
    private static instance: EventLanding;
    private static readonly CHARACTER_LIMIT = 375;
    globalEventMonth:string = 'Select Month';
    globalIndex:number = 0;
    selectedItemLength:number = 0;
    maxItemsInOneGo:number = 5;
    maxItemsOnLoadMore:number = 3;
    itemsCurrentlyThatCanBeViewed: number = 5;
    isClickTriggered:boolean = false;
    dropDown:any;

    public static getInstance(): EventLanding {
        EventLanding.instance ??= new EventLanding();
        return EventLanding.instance;
    }

    public constructor() {
        this.init();
        // Only run getCharacterCount if there are event cards on the page.
        if (document.querySelector('.events-card')) {
            this.applyReadMore();
        }
    }

    displayOnlySelectedMonth(){
        this.isClickTriggered = false;
        const month = (document.getElementById("filter-event") as HTMLSelectElement).value;
        this.globalIndex = 0;
        this.selectedItemLength = 0;
        this.globalEventMonth = month;
        const allEvents = document.querySelectorAll(".events-list>.event-wrapper");
        allEvents.forEach((el)=>{
            const monthCard = el as HTMLElement;
            monthCard.style.display = "none";
        });
        if(month!=="Select Month" && document.getElementById(month)){
            const monthCard = document.getElementById(month) as HTMLElement;
            monthCard.style.display = "flex";
        }
            
        else{
            allEvents.forEach((el)=>{
                const monthCard = el as HTMLElement;
                monthCard.style.display = "flex";
            });
        }
        
        this.setGlobalValuesToEventLength();

        this.showFiveContents();
    
    }

    showFiveContents() {
        this.itemsCurrentlyThatCanBeViewed = this.isClickTriggered 
            ? this.maxItemsInOneGo + (this.maxItemsOnLoadMore * this.globalIndex) 
            : this.maxItemsInOneGo;
    
        this.globalIndex += 1;
    
        let parentMonth = new Set();
    
        let selector = this.globalEventMonth === "Select Month" 
            ? ".event-wrapper>.events-card" 
            : `#${this.globalEventMonth}>.events-card`;
    
        let allEvents = document.querySelectorAll(selector);
    
        if (allEvents) {
            allEvents.forEach((el, index) => {
                const parentWrapper = el.parentNode as HTMLElement;
                const titleTarget = document.getElementById(parentWrapper.id) as HTMLElement;
                const targetTitleMonth = titleTarget.querySelector(".event-list-date") as HTMLElement;
                const eventCard = el as HTMLElement;
    
                if (index > this.itemsCurrentlyThatCanBeViewed - 1) {
                    eventCard.style.display = "none";
                } else {
                    eventCard.style.display = "block";
                    parentMonth.add(parentWrapper.id);
                }
    
                // Add or remove title months
                targetTitleMonth?.classList.toggle("hidden", !parentMonth.has(parentWrapper.id));
            });
        }
    
        // Check if load more buttons should be shown
        const buttonDOM = document.getElementById("load_more_events") as HTMLElement;
        const hideDiv = document.getElementById("load-more") as HTMLElement;
        const backToTopButton = document.getElementById("back_to_top");
        const backToTopWrapper = backToTopButton?.parentNode as HTMLElement;
    
        if (buttonDOM) {
            const shouldHide = this.selectedItemLength < (this.maxItemsInOneGo + 1) || (this.itemsCurrentlyThatCanBeViewed) > this.selectedItemLength - 1;
            buttonDOM.classList.toggle("hidden", shouldHide);
            hideDiv.classList.toggle("hidden", shouldHide);
    
            if (backToTopButton) {
                backToTopWrapper?.classList.toggle("hidden", !shouldHide);
                backToTopButton.removeEventListener("click", this.scrollToTop);
                if (shouldHide) {
                    backToTopButton.addEventListener("click", this.scrollToTop);
                }
            }
        }
    
        this.isClickTriggered = true;
    }
    
    

    setGlobalValuesToEventLength(){
        const childArticles = document.getElementById(this.globalEventMonth)

        if(childArticles)
            this.selectedItemLength = childArticles.querySelectorAll(".events-card").length;
        else
            this.selectedItemLength = document.querySelectorAll(".events-list>.event-wrapper>.events-card").length;
    }

    scrollToTop() {
        scrollTo(0, 0);
    }

    checkIfLoadMoreNeedsToBeShown(){
        //to check if load more buttons should be shown
        const buttonDOM =  document.getElementById("load_more_events") as HTMLElement;
        if(buttonDOM){
            if(this.selectedItemLength< (this.maxItemsInOneGo+1) || (this.globalIndex*this.maxItemsInOneGo)>this.selectedItemLength-1){
                buttonDOM.classList.add("hidden");
                const backToTopButton = document.getElementById("back_to_top");
                if(backToTopButton){
                    const backToTopWrapper = backToTopButton.parentNode as HTMLElement;
                    backToTopWrapper?.classList.remove("hidden");
                    backToTopButton.addEventListener("click", this.scrollToTop);
                }
            }
            else{
                buttonDOM.classList.remove("hidden");
                const backToTopButton = document.getElementById("back_to_top");
                if(backToTopButton){
                    const backToTopWrapper = backToTopButton.parentNode as HTMLElement;
                    backToTopWrapper?.classList.add("hidden");
                    backToTopButton.removeEventListener("click", this.scrollToTop);
                }
            }
        }
      }

    private init() {
        this.isClickTriggered = false;
        
        // Setup event delegation ONLY for read more buttons on card containers
        this.setupReadMoreEventDelegation();
        
        if(document.getElementById("load_more_events") && document.getElementById("filter-event")){
            document.getElementById("load_more_events")?.addEventListener("click", this.showFiveContents.bind(this));
            this.dropDown = document.getElementById("filter-event");
            document.getElementById("filter-event")?.addEventListener("change", this.displayOnlySelectedMonth.bind(this));
            this.setGlobalValuesToEventLength();
            this.showFiveContents();
        }
    }

    private setupReadMoreEventDelegation() {
        // Find all possible card list containers
        const cardContainers = document.querySelectorAll('.events-list, .card-list');
        
        cardContainers?.forEach(container => {
            container?.addEventListener('click', (event) => {
                const target = event.target as HTMLElement;
                
                if (target?.classList.contains('read-more-btn') || 
                    (target?.tagName === 'BUTTON' && 
                     (target?.textContent?.includes('Read more') || target?.textContent?.includes('Read less')))) {
                    event?.preventDefault();
                    this.handleReadMoreToggle(target);
                }
            });
        });
    }


    private handleReadMoreToggle(button: HTMLElement) {
        const eventCard = button?.closest('.events-card') as HTMLElement;
        if (!eventCard) return;

        const isReadingMore = button?.textContent === 'Read more';
        
        if (isReadingMore) {
            this.expandCard(eventCard, button);
        } else {
            this.collapseCard(eventCard, button);
        }
    }

    private expandCard(eventCard: HTMLElement, button: HTMLElement) {
        const originalContent = JSON.parse(eventCard?.dataset?.originalContent || '[]');
        const allParagraphs = Array.from(eventCard?.querySelectorAll<HTMLParagraphElement>('p'));
        const contentParagraphs = allParagraphs?.filter(p => !p?.closest('.events-location'));
        
        contentParagraphs?.forEach((p, index) => {
            p.innerHTML = originalContent[index];
            p.style.display = '';
        });
        
        // Re-append the button to the last paragraph
        contentParagraphs[contentParagraphs.length - 1]?.appendChild(button);
        button.textContent = 'Read less';
    }

    private collapseCard(eventCard: HTMLElement, button: HTMLElement) {
        const characterLimit = EventLanding.CHARACTER_LIMIT;
        const allParagraphs = Array.from(eventCard.querySelectorAll<HTMLParagraphElement>('p'));
        const contentParagraphs = allParagraphs.filter(p => !p.closest('.events-location'));

        let totalLength = 0;
        let truncated = false;

        // First, reset all paragraphs to their original state and make them visible
        const originalContent = JSON.parse(eventCard.dataset.originalContent || '[]');
        contentParagraphs.forEach((p, index) => {
            if (originalContent[index]) {
                p.innerHTML = originalContent[index];
            }
            p.style.display = '';
        });

        for (let i = 0; i < contentParagraphs.length; i++) {
            const p = contentParagraphs[i];
            const pLength = p.textContent?.replace(/\s/g, '')?.length || 0;

            if (totalLength + pLength >= characterLimit) {
                const remainingLength = characterLimit - totalLength;
                const truncatedHTML = this.truncateHTML(p.innerHTML, remainingLength);

                p.innerHTML = `${truncatedHTML} <span class="ellipsis">...</span>`;
                p.appendChild(button);

                // Hide all subsequent paragraphs
                for (let j = i + 1; j < contentParagraphs.length; j++) {
                    contentParagraphs[j].style.display = 'none';
                }

                truncated = true;
                break; 
            } else {
                totalLength += pLength;
            }
        }

        if (truncated) {
            button.textContent = 'Read more';
            eventCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }

    private truncateHTML(html: string, maxLength: number): string {
        if (maxLength <= 0) return '';

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        let textLength = 0;
        const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT);
        
        const nodesToRemove: Node[] = [];
        let node;
        let finished = false;

        while (!finished && (node = walker.nextNode())) {
            if (node.textContent) {
                const nodeText = node.textContent;
                const nodeLengthWithoutSpaces = nodeText.replace(/\s/g, '').length;

                if (textLength + nodeLengthWithoutSpaces > maxLength) {
                    const remainingLength = maxLength - textLength;
                    let endIndex = 0;
                    let count = 0;

                    for (let i = 0; i < nodeText.length; i++) {
                        if (nodeText[i].trim() !== '') {
                            count++;
                        }
                        if (count > remainingLength) {
                            break;
                        }
                        endIndex = i + 1;
                    }
                    node.textContent = nodeText.slice(0, endIndex);
                    finished = true;
                } else {
                    textLength += nodeLengthWithoutSpaces;
                }
            }
        }

        // After truncating, find all nodes that come after the current one and mark them for removal
        if (finished && node) {
            let nextNode = node.nextSibling;
            while(nextNode) {
                nodesToRemove.push(nextNode);
                nextNode = nextNode.nextSibling;
            }
            
            let parent = node.parentElement;
            while(parent && parent !== tempDiv) {
                let nextParentSibling = parent.nextSibling;
                while(nextParentSibling) {
                    nodesToRemove.push(nextParentSibling);
                    nextParentSibling = nextParentSibling.nextSibling;
                }
                parent = parent.parentElement;
            }
        }

        nodesToRemove.forEach(n => n.parentNode?.removeChild(n));
        
        return tempDiv.innerHTML;
    }

    private applyReadMore() {
        const eventCards = document.querySelectorAll<HTMLElement>('.events-card');
        const characterLimit = EventLanding.CHARACTER_LIMIT;
        
        eventCards?.forEach(card => {
            const allParagraphs = Array.from(card?.querySelectorAll<HTMLParagraphElement>('p'));
            const contentParagraphs = allParagraphs?.filter(p => !p?.closest('.events-location'));
            const totalCharacters = contentParagraphs?.reduce((sum, p) => sum + (p?.textContent?.length || 0), 0);
            
            if (totalCharacters > characterLimit) {
                const originalContent = contentParagraphs?.map(p => p.innerHTML);
                if(card) card.dataset.originalContent = JSON.stringify(originalContent);
                
                const readMoreBtn = document.createElement('button');
                readMoreBtn.classList.add('read-more-btn'); // Add class for event delegation
                readMoreBtn.textContent = 'Read more';
                readMoreBtn.style.textDecoration = 'underline';
                
                // Apply initial truncation
                this.collapseCard(card, readMoreBtn);
            }
        });
    }
}

EventLanding.getInstance();